import MomentDurationFormatSetup from 'moment-duration-format';
import Moment from 'moment-timezone';

MomentDurationFormatSetup(Moment);

export const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

Moment.tz.setDefault(userTimeZone);

export const isMoment = (value) => Moment.isMoment(value);

export const createNewDate = (value, format, timeZone) => {
    if (isMoment(value)) {
        if (timeZone) {
            return value.clone().tz(timeZone, false);
        }
        return value;
    }

    if (timeZone) {
        return Moment(value, format).tz(timeZone, false);
    }
    return Moment.parseZone(value, format);
};

export const createNewDateFromString = (value, format) => {
    if (!value) {
        return null;
    }

    return createNewDate(value, format);
};

export const createNewDateForBranch = (value, branch, format) => createNewDate(value, format, branch.timezone);

export const createNewUtcDate = (value, format) => Moment(value, format).utc(false);

export const createNewTime = (value, format = 'HH:mm', timeZone) => createNewDate(value, format, timeZone || userTimeZone);

export const createNewDuration = (value) => Moment.duration(value);

export default Moment;
